import {
  activeOrganizationsApi,
  createOrganizationsApi,
  deleteOrganizationsApi,
  editOrganizationsApi,
  getAllOrganizationsApi,
  setUserOrganizationsApi,
} from "../api/organizationApi";
import { failure, ORGANIZATION, request, success } from "./utilities";

export function getOrganizationList(data, token) {
  return (dispatch) => {
    dispatch(request(ORGANIZATION.GET_ORGANIZATION_REQUEST));
    getAllOrganizationsApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(
            success(ORGANIZATION.GET_ORGANIZATION_SUCCESS, res.data.data)
          );
        } else {
          dispatch(
            failure(ORGANIZATION.GET_ORGANIZATION_FAILURE, res.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ORGANIZATION.GET_ORGANIZATION_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function addOrganization(data, token, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(ORGANIZATION.ADD_ORGANIZATION_REQUEST));
    createOrganizationsApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(
            success(ORGANIZATION.ADD_ORGANIZATION_SUCCESS, res.data.data)
          );
          if (moveToNext) {
            moveToNext();
          }
        } else {
          dispatch(
            failure(ORGANIZATION.ADD_ORGANIZATION_FAILURE, res.data.message)
          );
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            ORGANIZATION.ADD_ORGANIZATION_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function editOrganization(data, token, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(ORGANIZATION.EDIT_ORGANIZATION_REQUEST));
    editOrganizationsApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(
            success(ORGANIZATION.EDIT_ORGANIZATION_SUCCESS, res.data.data)
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(res.data.message, "success");
          }
        } else {
          dispatch(
            failure(ORGANIZATION.EDIT_ORGANIZATION_FAILURE, res.data.message)
          );
          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            ORGANIZATION.EDIT_ORGANIZATION_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function deleteOrganization(id, token, Notification) {
  return (dispatch) => {
    dispatch(request(ORGANIZATION.DELETE_ORGANIZATION_REQUEST));
    deleteOrganizationsApi(id, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(success(ORGANIZATION.DELETE_ORGANIZATION_SUCCESS, id));
        } else {
          dispatch(
            failure(ORGANIZATION.DELETE_ORGANIZATION_FAILURE, res.data.message)
          );

          if (Notification) {
            Notification(res.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            ORGANIZATION.DELETE_ORGANIZATION_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function activeOrganization(data, moveToNext) {
  return (dispatch) => {
    dispatch(request(ORGANIZATION.ACTIVE_ORGANIZATION_REQUEST));
    activeOrganizationsApi(data).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(
            success(ORGANIZATION.ACTIVE_ORGANIZATION_SUCCESS, res.data.data)
          );
          if (moveToNext) moveToNext(res);
        } else {
          dispatch(
            failure(ORGANIZATION.ACTIVE_ORGANIZATION_FAILURE, res.data.message)
          );
          if (moveToNext) moveToNext(res);
        }
      },
      (error) => {
        dispatch(
          failure(
            ORGANIZATION.ACTIVE_ORGANIZATION_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function setUserOrganization(data, token, onSuccess) {
  return (dispatch) => {
    dispatch(request(ORGANIZATION.SET_USER_ORGANIZATION_REQUEST));
    setUserOrganizationsApi(data, token).then(
      (res) => {
        if (res.data.status === 200) {
          dispatch(
            success(ORGANIZATION.SET_USER_ORGANIZATION_SUCCESS, res.data.data)
          );
          onSuccess(res.data.data);
        } else {
          dispatch(
            failure(
              ORGANIZATION.SET_USER_ORGANIZATION_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ORGANIZATION.GET_ORGANIZATION_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
